import { useQuery } from "@tanstack/react-query";

import useApiHelper from "../hooks/useApiHelper";
import { IDriverTrackingLatestResponse, IDriverTrackingResponse } from "../models/DriverTracking";

export default function useDriverTrackingLatest() {
  const { get } = useApiHelper();

  const driverTrackingLatest = useQuery({
    queryKey: ["driverTracking", "latest"],
    queryFn: () => get<IDriverTrackingResponse>(`/tracking/latest`),
    staleTime: 30000, //30 seconds
  });


  return {
    driverTrackingLatest,
  };
}
